var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCross(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,-952.36218)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 77.577197,974.78495 c -1.95267,-1.9527 -5.11846,-1.9526 -7.07107,0 l -20.50616,20.5062 -20.50611,-20.5061 c -1.9526,-1.9526 -5.11838,-1.9527 -7.07106,0 -1.95267,1.9527 -1.95261,5.1185 0,7.0711 l 20.5061,20.50605 -20.50603,20.506 c -1.9526,1.9526 -1.95267,5.1184 0,7.0711 1.95268,1.9527 5.11847,1.9526 7.07107,0 l 20.50603,-20.5061 20.5061,20.5062 c 1.95259,1.9526 5.11839,1.9526 7.07106,0 1.952674,-1.9527 1.952614,-5.1185 10e-6,-7.0711 l -20.5061,-20.5061 20.50616,-20.50615 c 1.952614,-1.9526 1.952684,-5.1184 0,-7.0711 z",
    style: {
      textIndent: 0,
      textTransform: "none",
      direction: "ltr",
      blockProgression: "tb",
      baselineShift: "baseline",
      color: "#000000",
      enableBackground: "accumulate"
    },
    fillOpacity: 1,
    visibility: "visible",
    display: "inline"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCross);
export default __webpack_public_path__ + "static/media/icon-cross.e57004a8ba66ec9b5d8a46e056d89271.svg";
export { ForwardRef as ReactComponent };